<template>
  <div :class="{ 'is-error-color': color }">
    <span class="keywords-errors__container">{{
      singular ? $t('keyword-criteria.invalid') : $t('keywords-criteria.invalid')
    }}</span>
    <span v-if="!validation.length" class="keywords-errors__error">
      {{ singular ? $t('keyword-criteria.length') : $t('keywords-criteria.length') }}
    </span>
    <span v-if="!validation.ends" class="keywords-errors__error">
      {{ singular ? $t('keyword-criteria.ends') : $t('keywords-criteria.ends') }}
    </span>
    <span v-if="!validation.balanced" class="keywords-errors__error">
      {{ singular ? $t('keyword-criteria.balanced') : $t('keywords-criteria.balanced') }}
    </span>
    <span v-if="!validation.bracket" class="keywords-errors__error">
      {{ singular ? $t('keyword-criteria.bracket') : $t('keywords-criteria.bracket') }}
    </span>
    <span v-if="!validation.numberInsideBracket" class="keywords-errors__error">
      {{ singular ? $t('keyword-criteria.number-inside-bracket') : $t('keywords-criteria.number-inside-bracket') }}
    </span>
    <span v-if="!validation.bracketEmpty" class="keywords-errors__error">
      {{ singular ? $t('keyword-criteria.bracket-empty') : $t('keywords-criteria.bracket-empty') }}
    </span>
    <span v-if="!validation.numberInsideSpecialBracket" class="keywords-errors__error">
      {{
        singular
          ? $t('keyword-criteria.number-inside-special-bracket')
          : $t('keywords-criteria.number-inside-special-bracket')
      }}
    </span>
    <span v-if="!validation.emptyKeywordAfterBracket" class="keywords-errors__error">
      {{
        singular
          ? $t('keyword-criteria.empty-keyword-after-bracket')
          : $t('keywords-criteria.empty-keyword-after-bracket')
      }}
    </span>
    <span v-if="!validation.punctuation" class="keywords-errors__error">
      {{ singular ? $t('keyword-criteria.punctuation') : $t('keywords-criteria.punctuation') }}
    </span>
    <span v-if="!validation.asteriskTild" class="keywords-errors__error">
      {{ singular ? $t('keyword-criteria.asteriskTild') : $t('keywords-criteria.asteriskTild') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'KeywordsErrors',
  props: {
    validation: Object,
    color: String,
    singular: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.keywords-errors {
  &__container {
    display: block;
    font-weight: bold;
    text-align: left;
    padding: 5px;
  }

  &__error {
    display: block;
    display: list-item;
    list-style-type: disc;
    list-style-position: inside;
    text-align: left;
    padding: 2px;
  }
}

.is-error-color {
  color: $color-error;
}
</style>
